<template>
  <category-page
    :resource-params="resourceParams"
    :available-filters="availableFilters"
    :header-image="headerImage"
    :translated-description="
      category.slug === 'free'
        ? $t('categories.free.description')
        : $t('categories.premium.description')
    "
  />
</template>

<script>
import CategoryPage from '~/components/category/CategoryPage.vue';

const root = 'resource-availability';

export default {
  name: 'ResourceAvaliability',
  components: {
    CategoryPage,
  },
  async asyncData({ store, route, params, error }) {
    const data = {};
    const loggedInUser = store.getters.loggedInUser;

    // For the resource list query
    data.resourceParams = {
      category: params.slug,
      perPage: 32,
      root,
    };

    // Auto-select user's year level(s) when making a query
    if (loggedInUser && loggedInUser.year_levels) {
      data.resourceParams.year_levels = loggedInUser.year_levels;
    }

    try {
      // Load the category title, description and list of sub-categories
      const category = await store.dispatch('loadCategory', {
        category: params.slug,
        root,
        link: route.path,
      });

      // For meta fields
      data.title = category.name + ' Teaching Resources';
      data.category = category;
      data.headerImage =
        category.slug === 'free'
          ? '/images/banners/section-free-teaching-resources.png'
          : '/images/banners/section-teaching-resources.png';
    } catch (err) {
      // No page matching this route
      error({ statusCode: 404, message: err.message, path: route.path });
    }

    return data;
  },
  data() {
    return {
      title: 'Teaching Resources by resource availability',
      category: {},
      resourceParams: {},
      availableFilters: [
        'types',
        'resource_types',
        'learning_areas',
        'year_levels',
        'file_formats',
        'publishers',
      ],
    };
  },
  jsonld() {
    return this.$jsonSchemaPage(this.title, this.$route.path);
  },
  head() {
    return {
      title: this.category.slug === 'free' ? this.category.title || this.category.name : this.title,
      meta: this.$metaPropertiesCategory(this.category),
      link: this.$hrefLangsPage(this.$route),
    };
  },
  mounted() {
    this.$mzAnalyticsApi({ event: 'pageView' });
  },
};
</script>
